import { ModelBase } from 'store/model-base';

export class CmsWatches extends ModelBase {
    public static storeName: string = 'cmsWatches';

    public nav: CmsWatchNav;
    public termsConditions: CmsWatchTermsConditions;
    public standAloneTermsConditions: CmsWatchTermsConditions;
    public address: CmsAddressFields;
    public addAddress: CmsWatchAddress;
    public verifyAddress: CmsWatchVerifyAddress;
    public savedAddress: CmsWatchSavedAddress;
    public progress: CmsWatchProgress;
    public standaloneProgress: CmsStandaloneInProgressActivation;
    public standaloneComplete: CmsStandaloneCompleteActivation;
    public eligibility: CmsWatchEligibility;
    public getStarted: CmsWatchGetStarted;
    public welcomeBack: CmsWatchWelcomeBack;
    public errors: CmsWatchError[];
    public comingSoon: CmsWatchComingSoon;
    public secondaryUser: CmsNonXfinityCustomer;
    public chooseReplaceDevice: CmsChooseReplaceDevice;
    public addReplaceDevice: CmsWatchAddReplaceDevice;
    public confirmReplaceDevice: CmsConfirmReplaceDevice;
    public replacedDeviceActivation: CmsReplacedDeviceActivation;
    public changeHostDeviceActivation: CmsReplacedDeviceActivation;
    public splashStandalone: CmsSplashStandaloneWatches;
}
